import { countryLabel } from './countryLabel';

/** Queued — the run hasn't been picked up yet (waiting for a free slot).
 *  No stepper because no work is happening. */
export function QueuedBanner({ country }: { country?: string | null }) {
  return (
    <div className="mb-[18px] py-[22px] px-[26px] bg-state-warning-bg-soft border border-state-warning-border rounded-xl text-center">
      <div className="text-[11px] font-semibold tracking-[0.18em] uppercase text-state-warning-text/80 mb-1.5">
        Queued
      </div>
      {country && (
        <div className="font-sans text-electric text-[22px] font-bold tracking-tight mb-2">
          {countryLabel(country)}
        </div>
      )}
      <p className="text-sm text-state-warning-text/90 max-w-[480px] mx-auto m-0 leading-[1.55]">
        Waiting in queue. This run will start automatically as soon as
        a slot is free.
      </p>
    </div>
  );
}
